import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import LoginIcon from "@mui/icons-material/Login";
import { Typography, Button, Box } from "@mui/material";
import { useLocation } from "wouter";
export function ChatAuthenticate({ backgroundColor, textColor, }) {
    const [, setLocation] = useLocation();
    return (_jsx(Box, Object.assign({ sx: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
        } }, { children: _jsxs(Box, Object.assign({ sx: {
                color: "white",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                m: 2,
            } }, { children: [_jsx(Typography, Object.assign({ variant: "body1" }, { children: "Please log in to use the chat" })), _jsx(Button, Object.assign({ size: "small", color: "info", variant: "outlined", startIcon: _jsx(LoginIcon, { fontSize: "small" }), 
                    // fullWidth
                    onClick: () => setLocation("/login"), sx: {
                        color: textColor,
                        borderColor: textColor,
                        "&:hover": {
                            borderColor: textColor,
                            color: textColor,
                        },
                        "&:active": {
                            borderColor: textColor,
                            color: textColor,
                        },
                        "&:focus": {
                            borderColor: textColor,
                            color: textColor,
                        },
                    } }, { children: "Log in" }))] })) })));
}
